import {timerTypes} from "./type";
import {BaseReducer} from "../../reducers/base";

const types = timerTypes;

const initialState = {
    datas: [],
    data: {},
    isLoading: false,
    success: false,
    msg: {},
};

const timerReducer = (state = initialState, action) => {
    const baseClass = new BaseReducer(types, state, action);

    return baseClass.baseReducer();
};

export default timerReducer;
